/**
 * Created by RSchweber-Koren on 5/12/2017.
 */

import makePropsEnumerable from "../../utility/MakePropsEnumerable";

const mResultStatus = new WeakMap();
const mDeleteTarget = new WeakMap();

class ConfirmDeleteDialogResult {
    constructor({status, deleteTarget}) {
        mResultStatus.set(this, status);
        mDeleteTarget.set(this, deleteTarget);
    }

    get status() {
        return mResultStatus.get(this);
    }

    get deleteTarget() {
        return mDeleteTarget.get(this);
    }
}

makePropsEnumerable(ConfirmDeleteDialogResult.prototype, [
    "status",
    "deleteTarget"
]);

export default ConfirmDeleteDialogResult;


//////////////////
// WEBPACK FOOTER
// ./src/views/confirm-delete-dialog/ConfirmDeleteDialogResult.js
// module id = qWaj
// module chunks = 1